function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M381.891 232.885H0V233.063H381.891V232.885Z",
  fill: "#E6E6E6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95.3353 243.645H70.0388V243.823H95.3353V243.645Z",
  fill: "#E6E6E6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M62.0343 243.645H47.3773V243.823H62.0343V243.645Z",
  fill: "#E6E6E6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M160.814 246.262H146.157V246.44H160.814V246.262Z",
  fill: "#E6E6E6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M237.238 250.23H204.251V250.408H237.238V250.23Z",
  fill: "#E6E6E6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M197.453 250.23H192.618V250.408H197.453V250.23Z",
  fill: "#E6E6E6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M346.26 246.262H274.709V246.44H346.26V246.262Z",
  fill: "#E6E6E6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M181.017 201.169H33.5381C32.3828 201.167 31.2755 200.739 30.4592 199.977C29.643 199.216 29.1846 198.184 29.1846 197.109V4.08748C29.1946 3.01796 29.6575 1.99533 30.4726 1.2417C31.2878 0.48808 32.3894 0.0643321 33.5381 0.0625H181.017C182.173 0.0625 183.283 0.490305 184.101 1.2518C184.918 2.0133 185.378 3.04611 185.378 4.12304V197.109C185.378 198.186 184.918 199.219 184.101 199.98C183.283 200.742 182.173 201.169 181.017 201.169ZM33.5381 0.204726C32.4334 0.20661 31.3747 0.616514 30.5943 1.34447C29.8138 2.07242 29.3755 3.05894 29.3755 4.08748V197.109C29.3755 198.137 29.8138 199.124 30.5943 199.852C31.3747 200.58 32.4334 200.99 33.5381 200.992H181.017C182.122 200.99 183.182 200.58 183.963 199.852C184.745 199.124 185.185 198.138 185.187 197.109V4.08748C185.185 3.05829 184.745 2.07178 183.963 1.34403C183.182 0.616283 182.122 0.206606 181.017 0.204726H33.5381Z",
  fill: "#E6E6E6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M346.23 201.169H198.743C197.587 201.167 196.479 200.739 195.662 199.978C194.844 199.217 194.384 198.185 194.382 197.109V4.08748C194.394 3.01731 194.859 1.99469 195.675 1.24126C196.491 0.487831 197.594 0.0643122 198.743 0.0625H346.23C347.377 0.0662011 348.477 0.490776 349.29 1.2442C350.104 1.99762 350.565 3.01919 350.575 4.08748V197.109C350.575 198.183 350.118 199.214 349.303 199.975C348.489 200.736 347.384 201.166 346.23 201.169ZM198.743 0.204726C197.638 0.206606 196.578 0.616283 195.797 1.34403C195.015 2.07178 194.575 3.05829 194.573 4.08748V197.109C194.575 198.138 195.015 199.124 195.797 199.852C196.578 200.58 197.638 200.99 198.743 200.992H346.23C347.335 200.99 348.394 200.58 349.176 199.852C349.958 199.124 350.398 198.138 350.4 197.109V4.08748C350.398 3.05829 349.958 2.07178 349.176 1.34403C348.394 0.616283 347.335 0.206606 346.23 0.204726H198.743Z",
  fill: "#E6E6E6"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M204.235 172.141H187.44V234.173H204.235V172.141Z",
  fill: "#E0E0E0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M201.043 234.173H204.236V225.724H197.698L201.043 234.173Z",
  fill: "#FAFAFA"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M130.637 172.141H113.841V234.173H130.637V172.141Z",
  fill: "#E0E0E0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M204.235 172.141H127.857V228.989H204.235V172.141Z",
  fill: "#FAFAFA"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M201.463 174.936V189.976H130.607V174.936H201.44H201.463ZM201.738 174.658H130.332V190.246H201.761V174.658H201.738Z",
  fill: "#E0E0E0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M131.042 234.173H127.857V225.724H134.387L131.042 234.173Z",
  fill: "#FAFAFA"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M164.358 182.452C164.358 182.763 164.457 183.067 164.643 183.325C164.828 183.584 165.092 183.785 165.4 183.904C165.709 184.023 166.048 184.054 166.376 183.994C166.703 183.933 167.004 183.783 167.24 183.563C167.476 183.344 167.637 183.064 167.702 182.759C167.767 182.454 167.733 182.138 167.606 181.851C167.478 181.564 167.262 181.318 166.984 181.145C166.706 180.973 166.38 180.881 166.046 180.881C165.599 180.881 165.169 181.046 164.853 181.341C164.536 181.636 164.358 182.035 164.358 182.452Z",
  fill: "#E6E6E6"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M201.463 193.041V208.081H130.607V193.041H201.44H201.463ZM201.738 192.771H130.332V208.359H201.761V192.778L201.738 192.771Z",
  fill: "#E0E0E0"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M164.358 200.6C164.358 200.911 164.457 201.215 164.643 201.473C164.828 201.732 165.092 201.933 165.4 202.052C165.709 202.171 166.048 202.202 166.376 202.142C166.703 202.081 167.004 201.931 167.24 201.712C167.476 201.492 167.637 201.212 167.702 200.907C167.767 200.602 167.733 200.286 167.606 199.999C167.478 199.712 167.262 199.466 166.984 199.294C166.706 199.121 166.38 199.029 166.046 199.029C165.599 199.029 165.169 199.194 164.853 199.489C164.536 199.784 164.358 200.184 164.358 200.6Z",
  fill: "#E6E6E6"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M201.463 211.153V226.201H130.607V211.153H201.44H201.463ZM201.738 210.876H130.332V226.471H201.761V210.876H201.738Z",
  fill: "#E0E0E0"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M164.358 218.677C164.36 218.988 164.46 219.291 164.646 219.549C164.833 219.806 165.097 220.006 165.406 220.124C165.714 220.242 166.053 220.272 166.38 220.211C166.707 220.149 167.007 219.999 167.242 219.779C167.478 219.559 167.638 219.279 167.702 218.974C167.767 218.67 167.733 218.354 167.605 218.067C167.477 217.78 167.261 217.535 166.983 217.363C166.706 217.191 166.38 217.099 166.046 217.099C165.824 217.099 165.604 217.14 165.399 217.219C165.193 217.298 165.007 217.415 164.85 217.561C164.693 217.708 164.569 217.882 164.485 218.074C164.4 218.265 164.357 218.47 164.358 218.677Z",
  fill: "#E6E6E6"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M120.379 136.115H103.584V234.18H120.379V136.115Z",
  fill: "#E0E0E0"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M117.186 234.173H120.379V225.724H113.849L117.186 234.173Z",
  fill: "#FAFAFA"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M57.6123 136.115H40.8168V234.18H57.6123V136.115Z",
  fill: "#E0E0E0"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M120.379 136.115H54.8237V228.996H120.379V136.115Z",
  fill: "#FAFAFA"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M117.553 138.732V159.76H57.6499V138.732H117.553ZM117.905 138.412H57.2833V160.066H117.889V138.419L117.905 138.412Z",
  fill: "#E0E0E0"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M117.554 162.328V218.101H89.0193V162.328H117.554ZM117.906 162H88.6756V218.428H117.906V162Z",
  fill: "#E0E0E0"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M86.1848 162.328V218.101H57.6499V162.328H86.1848ZM86.5285 162H57.2833V218.428H86.5133V162H86.5285Z",
  fill: "#E0E0E0"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M58.0163 234.173H54.8237V225.724H61.3616L58.0163 234.173Z",
  fill: "#FAFAFA"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M85.9101 149.257C85.9085 149.57 86.0067 149.876 86.1921 150.136C86.3775 150.397 86.6418 150.6 86.9515 150.721C87.2612 150.841 87.6023 150.874 87.9317 150.813C88.2611 150.753 88.564 150.604 88.8019 150.383C89.0398 150.163 89.202 149.881 89.2681 149.575C89.3341 149.268 89.301 148.951 89.1729 148.662C89.0448 148.373 88.8275 148.126 88.5485 147.952C88.2695 147.778 87.9413 147.686 87.6056 147.686C87.1573 147.686 86.7271 147.851 86.4094 148.145C86.0916 148.44 85.9121 148.84 85.9101 149.257Z",
  fill: "#E6E6E6"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M91.9592 188.888C91.9592 189.201 92.0588 189.506 92.2455 189.766C92.4321 190.026 92.6974 190.228 93.0077 190.347C93.3179 190.467 93.6593 190.497 93.9884 190.436C94.3175 190.374 94.6196 190.223 94.8564 190.002C95.0933 189.78 95.2541 189.498 95.3187 189.192C95.3833 188.885 95.3486 188.567 95.2191 188.279C95.0896 187.991 94.8711 187.745 94.5912 187.572C94.3114 187.399 93.9828 187.308 93.6471 187.309C93.4248 187.309 93.2047 187.35 92.9994 187.43C92.7941 187.509 92.6077 187.625 92.4509 187.772C92.294 187.919 92.1698 188.093 92.0855 188.284C92.0011 188.476 91.9582 188.681 91.9592 188.888Z",
  fill: "#E6E6E6"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M79.8685 188.888C79.8701 189.199 79.9703 189.502 80.1567 189.759C80.3431 190.017 80.6073 190.217 80.9158 190.335C81.2244 190.453 81.5635 190.483 81.8905 190.421C82.2174 190.36 82.5174 190.21 82.7527 189.99C82.988 189.77 83.1481 189.49 83.2126 189.185C83.2771 188.88 83.2432 188.565 83.1152 188.278C82.9873 187.991 82.7709 187.746 82.4935 187.574C82.2161 187.401 81.89 187.309 81.5565 187.309C81.3342 187.309 81.1141 187.35 80.9088 187.43C80.7035 187.509 80.5171 187.625 80.3602 187.772C80.2034 187.919 80.0792 188.093 79.9948 188.284C79.9105 188.476 79.8675 188.681 79.8685 188.888Z",
  fill: "#E6E6E6"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M77.9589 108.772H70.8787C71.5312 111.97 71.9421 115.207 72.1084 118.458C72.1084 122.014 66.7161 136.115 74.3997 136.115C82.0834 136.115 76.6911 122.049 76.6911 118.458C76.87 115.206 77.2936 111.969 77.9589 108.772Z",
  fill: "#E0E0E0"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M51.021 123.194V127.461C51.0291 129.748 52.0085 131.94 53.7457 133.557C55.4828 135.174 57.8366 136.086 60.2933 136.094H64.876C67.3327 136.086 69.6865 135.174 71.4236 133.557C73.1608 131.94 74.1402 129.748 74.1483 127.461V123.194H51.021Z",
  fill: "#F5F5F5"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M149.449 163.095C149.449 168.073 155.429 172.141 162.739 172.141H169.338C176.647 172.141 182.628 168.073 182.628 163.095H149.449Z",
  fill: "#E0E0E0"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M324.309 155.799C320.307 158.843 314.777 164.411 309.721 172.248C306.345 177.467 304.313 182.915 303.42 190.154C303.42 181.976 303.473 173.193 303.504 164.902C304.52 162.768 306.842 157.847 308.507 153.965C314.059 141.001 316.144 137.808 321.132 126.629C327.8 111.695 334.628 94.0166 332.673 95.4317C328.686 98.3118 313.41 124.943 311.76 128.755C307.263 138.927 304.483 149.686 303.519 160.649C303.519 152.827 303.58 145.716 303.611 140.197C303.718 122.199 304.046 116.389 304.207 114.597C304.825 113.686 305.551 112.627 305.978 112.058C309.568 107.222 310.951 103.112 314.327 95.9011C319.123 85.6964 323.248 67.5698 322.041 68.48C317.015 72.2917 313.059 80.4696 307.85 90.9019C302.641 101.334 304.13 107.329 303.099 116.232C302.885 117.982 302.717 124.581 302.595 133.719C301.251 123.976 298.715 117.562 294.094 111.731C288.412 104.555 282.912 99.7127 278.88 97.1811C274.847 94.6495 285.845 112.271 291.1 119.937C295.782 126.792 300.097 132.83 302.557 138.782C302.427 151.177 302.366 166.864 302.366 181.45C301.159 174.808 299.188 167.647 296.561 162.107C293.399 155.451 288.541 145.239 284.669 141.776C283.745 140.944 288.717 160.806 291.91 166.082C295.102 171.359 297.447 176.344 299.456 179.338C299.922 180.049 301.48 182.73 302.366 184.28C302.366 202.108 302.473 217.838 302.641 223.193H303.466C303.412 221.813 303.397 212.739 303.42 200.735C305.413 194.221 309.965 186.783 313.723 179.999C317.817 172.653 328.311 152.777 324.309 155.799Z",
  fill: "#E0E0E0"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M315.014 234.173H291.077L289.267 212.327H316.824L315.014 234.173Z",
  fill: "#F0F0F0"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M318.603 214.873H287.479L286.593 207.498H319.497L318.603 214.873Z",
  fill: "#F5F5F5"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M94.9077 14.6406H52.0978V58.4105H94.9077V14.6406Z",
  fill: "#E0E0E0"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5436 14.6406H55.3207V58.4105H99.5436V14.6406Z",
  fill: "#F5F5F5"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M95.8392 54.9615V18.0896L59.025 18.0896V54.9615H95.8392Z",
  fill: "white"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M86.9106 46.0157V27.0215H67.9459V46.0157H86.9106Z",
  fill: "#F5F5F5"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M313.188 19.7393H273.418V60.4015H313.188V19.7393Z",
  fill: "#E0E0E0"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M317.496 19.7393H276.42V60.4015H317.496V19.7393Z",
  fill: "#F5F5F5"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M314.059 57.1942V22.9463L279.865 22.9463V57.1942H314.059Z",
  fill: "white"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M296.958 50.0046C302.851 50.0046 307.628 45.5568 307.628 40.0702C307.628 34.5835 302.851 30.1357 296.958 30.1357C291.065 30.1357 286.288 34.5835 286.288 40.0702C286.288 45.5568 291.065 50.0046 296.958 50.0046Z",
  fill: "#F5F5F5"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M139.382 40.7393H107.624V73.2093H139.382V40.7393Z",
  fill: "#E0E0E0"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M142.819 40.7393H110.015V73.2093H142.819V40.7393Z",
  fill: "#F5F5F5"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M140.07 70.649V43.2991H112.765V70.649H140.07Z",
  fill: "white"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M126.421 50.0547L118.951 62.1012H133.891L126.421 50.0547Z",
  fill: "#F5F5F5"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M190.945 265C272.733 265 339.035 261.396 339.035 256.95C339.035 252.504 272.733 248.9 190.945 248.9C109.158 248.9 42.8557 252.504 42.8557 256.95C42.8557 261.396 109.158 265 190.945 265Z",
  fill: "#F5F5F5"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M266.75 77.1702L259.173 74.3257C259.173 74.3257 249.175 91.3003 246.311 92.1607C242.416 93.327 234.35 96.5697 229.569 97.1386C228.92 97.8498 227.858 100.061 227.957 100.865C234.381 102.863 248.495 100.211 251.52 98.12C258.402 93.3768 266.75 77.1702 266.75 77.1702Z",
  fill: "#C78E6E"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M269.08 73.3086C270.493 78.1656 262.84 87.9365 262.84 87.9365L252.811 82.7026C252.811 82.7026 254.69 78.6848 256.982 74.5958C260.655 67.9894 267.468 67.769 269.08 73.3086Z",
  fill: "#FDBF21"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M269.08 73.3086C270.493 78.1656 262.84 87.9365 262.84 87.9365L252.811 82.7026C252.811 82.7026 254.69 78.6848 256.982 74.5958C260.655 67.9894 267.468 67.769 269.08 73.3086Z",
  fill: "black"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M256.791 84.7936L260.739 86.8559L261.435 75.5703C259.136 77.213 257.516 82.1625 256.791 84.7936Z",
  fill: "black"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M262.481 69.6538C262.481 69.6538 254.675 85.8249 259.227 115.934H289.984C290.473 111.539 288.854 90.0916 294.712 69.3836C291.338 68.7697 287.924 68.3634 284.493 68.1676C280.14 67.9327 275.777 67.9327 271.424 68.1676C268.407 68.4528 265.417 68.9497 262.481 69.6538Z",
  fill: "#FDBF21"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M262.481 69.6538C262.481 69.6538 254.675 85.8249 259.227 115.934H289.984C290.473 111.539 288.854 90.0916 294.712 69.3836C291.338 68.7697 287.924 68.3634 284.493 68.1676C280.14 67.9327 275.777 67.9327 271.424 68.1676C268.407 68.4528 265.417 68.9497 262.481 69.6538Z",
  fill: "black"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M255.347 257.59C255.301 258.358 266.964 258.977 281.392 258.977C295.82 258.977 307.567 258.358 307.613 257.59C307.659 256.822 296.003 256.211 281.568 256.211C267.132 256.211 255.401 256.829 255.347 257.59Z",
  fill: "#E8ECF1"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M275.878 237.411L270.423 239.377L275.122 250.679L280.577 248.713L275.878 237.411Z",
  fill: "#C78E6E"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M300.204 252.122H294.453L292.345 239.727H298.096L300.204 252.122Z",
  fill: "#C78E6E"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M294.055 251.503H300.517C300.629 251.503 300.737 251.541 300.823 251.608C300.908 251.676 300.965 251.77 300.983 251.873L301.815 256.63C301.833 256.75 301.823 256.871 301.785 256.986C301.748 257.102 301.684 257.208 301.599 257.299C301.513 257.389 301.408 257.461 301.29 257.51C301.172 257.559 301.043 257.584 300.914 257.583C298.661 257.548 297.576 257.42 294.735 257.42C292.986 257.42 289.389 257.59 286.96 257.59C284.531 257.59 284.371 255.371 285.371 255.165C289.862 254.262 291.604 253.032 293.101 251.837C293.365 251.621 293.704 251.502 294.055 251.503Z",
  fill: "black"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M274.961 249.668L281.071 248.004C281.18 247.976 281.296 247.983 281.4 248.024C281.505 248.065 281.59 248.139 281.644 248.232L283.935 252.498C283.988 252.607 284.016 252.724 284.015 252.844C284.014 252.963 283.985 253.08 283.931 253.188C283.876 253.295 283.797 253.391 283.699 253.467C283.601 253.543 283.486 253.599 283.362 253.629C281.14 254.198 279.65 254.547 276.87 255.3C274.953 255.819 272.998 256.666 271.104 257.227C269.79 257.619 266.704 257.633 265.108 257.633C262.748 257.633 262.221 255.315 263.237 255.208C265.795 254.945 266.139 255.066 267.552 254.404C269.864 253.463 271.959 252.116 273.723 250.436C274.056 250.083 274.483 249.818 274.961 249.668Z",
  fill: "black"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M230.532 97.1102L224.208 94.6426L221.603 101.171C224.195 101.538 226.832 101.538 229.424 101.171L230.532 97.1102Z",
  fill: "#C78E6E"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M219.502 94.4722L219.334 98.81L221.603 101.157L224.207 94.6286L219.502 94.4722Z",
  fill: "#C78E6E"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M276.627 238.37L271.154 240.337L273.578 246.182L279.05 244.215L276.627 238.37Z",
  fill: "#CF6F64"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M298.096 239.727H292.345L293.437 246.12H299.188L298.096 239.727Z",
  fill: "#CF6F64"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M258.25 107.791C258.364 109.079 258.494 110.394 258.662 111.745L281.53 104.833C285.101 103.848 288.205 101.758 290.329 98.9095C290.42 97.0108 290.535 95.0125 290.71 92.9289C290.787 91.9191 290.878 90.8808 290.978 89.8284C291.077 88.7759 291.215 87.6097 291.36 86.4861L258.25 107.791Z",
  fill: "black"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M265.72 84.4665L264.956 84.3812C265.407 80.8256 268.256 78.0237 271.257 78.0948V78.806C268.63 78.7562 266.125 81.2807 265.72 84.4665Z",
  fill: "white"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M269.791 91.0303H269.661V90.3192C272.288 90.4116 274.756 87.8587 275.16 84.6799L275.924 84.7653C275.519 88.2427 272.762 91.0303 269.791 91.0303Z",
  fill: "white"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M284.066 54.4639C282.989 58.3822 281.721 65.5575 284.493 68.1673C284.493 68.1673 282.553 72.1425 274.74 72.1425C267.598 72.1425 271.425 68.1673 271.425 68.1673C276.176 67.129 276.26 63.9005 275.633 60.8427L284.066 54.4639Z",
  fill: "#C78E6E"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M280.628 57.0669L275.641 60.843C275.795 61.5457 275.885 62.2594 275.908 62.9764C277.367 64.3275 280.292 60.907 280.59 59.1576C280.741 58.4689 280.754 57.76 280.628 57.0669Z",
  fill: "#CF6F64"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M267.064 54.4141C267.411 54.9741 267.878 55.4615 268.437 55.8457C268.995 56.2299 269.633 56.5027 270.31 56.647C272.143 57.0239 273.059 55.4523 272.555 53.8736C272.105 52.4514 270.6 50.5385 268.736 50.8656C268.337 50.9421 267.963 51.1066 267.647 51.3453C267.33 51.584 267.079 51.8899 266.915 52.2374C266.751 52.5849 266.679 52.9638 266.705 53.3425C266.731 53.7213 266.854 54.0887 267.064 54.4141Z",
  fill: "#CF6F64"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M270.096 41.8771C267.239 43.0932 266.231 53.6605 269.821 55.225C273.411 56.7895 275.503 39.566 270.096 41.8771Z",
  fill: "black"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M284.937 48.5688C284.249 53.8738 284.173 56.9956 281.118 59.7121C280.171 60.6136 278.975 61.2539 277.662 61.5625C276.349 61.871 274.97 61.8357 273.677 61.4605C272.385 61.0853 271.228 60.3847 270.336 59.4362C269.444 58.4876 268.851 57.328 268.622 56.0854C267.698 51.3208 268.973 43.4486 274.687 41.3366C275.887 40.8436 277.207 40.6586 278.51 40.8006C279.813 40.9426 281.052 41.4066 282.097 42.1443C283.143 42.8821 283.958 43.8669 284.457 44.9965C284.956 46.1261 285.122 47.3595 284.937 48.5688Z",
  fill: "#C78E6E"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M275.549 44.6219C279.781 43.6193 282.889 42.9366 281.774 46.2149C280.3 50.5954 278.528 54.8337 280.904 55.0257C282.355 55.1466 288.771 52.615 287.953 50.0478C287.243 47.8149 290.245 47.2033 290.779 46.0726C292.757 41.9765 287.098 42.517 288.106 40.0281C289.114 37.5391 283.523 33.5284 280.468 35.5266C275.496 38.7551 266.965 38.7054 271.448 33.3932C274.663 29.6029 268.927 30.3781 268.927 30.3781C268.927 30.3781 272.395 32.291 266.56 35.2493C260.388 38.4067 266.048 46.8904 275.549 44.6219Z",
  fill: "black"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M287.182 54.4141C286.346 55.5395 285.091 56.3354 283.661 56.647C281.774 57.0239 281.048 55.4523 281.759 53.8736C282.393 52.4514 284.134 50.5385 285.937 50.8656C287.739 51.1927 288.152 53.0203 287.182 54.4141Z",
  fill: "#C78E6E"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M259.227 115.934C259.227 115.934 254.064 158.957 253.659 175.284C253.246 192.266 271.157 245.252 271.157 245.252L280.322 241.697C280.322 241.697 269.629 193.283 271.157 176.607C272.776 158.423 279.467 115.962 279.467 115.962L259.227 115.934Z",
  fill: "#FDBF21"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M272.058 127.746C267.942 135.696 270.714 151.419 272.944 160.735C273.792 154.157 274.8 147.017 275.755 140.411C275.663 130.256 274.816 122.412 272.058 127.746Z",
  fill: "black"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M279.918 238.881C279.964 238.881 281.002 241.597 281.002 241.597L270.432 245.736L268.766 242.849L279.918 238.881Z",
  fill: "#FDBF21"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M270.142 115.934C270.142 115.934 274.09 156.852 276.702 172.177C279.574 188.966 290.832 244.882 290.832 244.882H301.365C301.365 244.882 295.056 190.325 293.865 173.698C292.566 155.664 289.985 115.934 289.985 115.934H270.142Z",
  fill: "#FDBF21"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M301.526 242.33C301.571 242.33 301.877 245.067 301.877 245.067H290.298L289.473 241.924L301.526 242.33Z",
  fill: "#FDBF21"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M297.493 239.087C297.469 239.087 297.446 239.079 297.428 239.065C297.41 239.051 297.398 239.031 297.394 239.009C297.333 238.511 291.643 189.23 290.573 174.296C289.412 158.097 287.075 122.163 287.052 121.801C287.051 121.789 287.053 121.777 287.057 121.766C287.061 121.755 287.068 121.744 287.076 121.736C287.085 121.727 287.095 121.72 287.107 121.715C287.119 121.711 287.131 121.708 287.144 121.708C287.169 121.708 287.193 121.717 287.212 121.733C287.23 121.749 287.241 121.77 287.243 121.794C287.243 122.156 289.603 158.061 290.764 174.289C291.834 189.223 297.524 238.468 297.577 239.002C297.579 239.013 297.579 239.025 297.576 239.037C297.573 239.048 297.567 239.059 297.559 239.069C297.551 239.078 297.541 239.086 297.53 239.091C297.519 239.097 297.506 239.1 297.493 239.101V239.087Z",
  fill: "black"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M276.199 50.0479C276.199 50.4817 275.909 50.8301 275.603 50.8301C275.298 50.8301 275.076 50.4817 275.107 50.0479C275.137 49.6141 275.397 49.2656 275.703 49.2656C276.008 49.2656 276.23 49.6212 276.199 50.0479Z",
  fill: "black"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M270.959 50.0479C270.959 50.4817 270.661 50.8301 270.363 50.8301C270.065 50.8301 269.836 50.4817 269.859 50.0479C269.882 49.6141 270.157 49.2656 270.463 49.2656C270.768 49.2656 270.99 49.6212 270.959 50.0479Z",
  fill: "black"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M272.609 50.2683C271.971 51.5929 271.15 52.8338 270.165 53.959C270.929 54.6701 272.357 54.343 272.357 54.343L272.609 50.2683Z",
  fill: "#DF5753"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M272.747 56.1566C272.729 56.1566 272.711 56.1532 272.695 56.1467C272.679 56.1402 272.664 56.1307 272.652 56.1187C272.64 56.1067 272.631 56.0925 272.624 56.077C272.618 56.0615 272.616 56.045 272.617 56.0285C272.619 55.994 272.635 55.9614 272.662 55.9376C272.689 55.9137 272.725 55.9005 272.762 55.9005C273.346 55.9043 273.924 55.7862 274.452 55.5548C274.981 55.3235 275.447 54.9848 275.817 54.5636C275.844 54.5421 275.877 54.5303 275.913 54.5303C275.948 54.5303 275.982 54.5421 276.008 54.5636C276.033 54.5875 276.047 54.6194 276.047 54.6525C276.047 54.6857 276.033 54.7175 276.008 54.7414C275.612 55.189 275.114 55.5484 274.55 55.7933C273.985 56.0382 273.369 56.1623 272.747 56.1566Z",
  fill: "black"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M277.13 48.7396C277.094 48.7571 277.053 48.7662 277.012 48.7662C276.971 48.7662 276.93 48.7571 276.893 48.7396C276.608 48.5677 276.283 48.4607 275.944 48.4273C275.606 48.394 275.264 48.4352 274.946 48.5476C274.915 48.5621 274.881 48.5706 274.846 48.5727C274.812 48.5747 274.777 48.5704 274.744 48.5597C274.712 48.5491 274.681 48.5325 274.656 48.5109C274.63 48.4893 274.609 48.4631 274.594 48.4339C274.566 48.3706 274.565 48.2995 274.593 48.2357C274.62 48.172 274.672 48.1206 274.74 48.0925C275.139 47.9407 275.572 47.8808 276.001 47.9179C276.431 47.9551 276.844 48.0881 277.207 48.3059C277.236 48.3244 277.261 48.3482 277.28 48.3758C277.3 48.4034 277.313 48.4343 277.319 48.4667C277.326 48.4991 277.325 48.5324 277.317 48.5646C277.31 48.5968 277.296 48.6273 277.275 48.6543C277.237 48.6951 277.186 48.7247 277.13 48.7396Z",
  fill: "black"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M268.935 47.3171C268.894 47.3079 268.857 47.2882 268.828 47.2602C268.803 47.237 268.782 47.2093 268.769 47.1788C268.755 47.1483 268.748 47.1155 268.748 47.0824C268.748 47.0493 268.755 47.0165 268.769 46.986C268.782 46.9554 268.803 46.9278 268.828 46.9046C269.121 46.5989 269.485 46.3603 269.893 46.2073C270.301 46.0544 270.742 45.9912 271.18 46.0228C271.215 46.0279 271.249 46.0396 271.279 46.0572C271.309 46.0749 271.335 46.0981 271.355 46.1254C271.375 46.1527 271.389 46.1836 271.396 46.2161C271.402 46.2486 271.402 46.2821 271.394 46.3144C271.378 46.3802 271.336 46.4382 271.277 46.4775C271.218 46.5168 271.146 46.5346 271.073 46.5277C270.726 46.5073 270.379 46.5608 270.057 46.684C269.736 46.8072 269.449 46.9969 269.217 47.2388C269.183 47.2748 269.138 47.3012 269.088 47.315C269.038 47.3288 268.985 47.3295 268.935 47.3171Z",
  fill: "black"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M297.669 76.3812L289.725 74.4114C289.725 74.4114 281.935 92.2678 279.177 93.4269C275.435 95.0199 265.956 100.538 261.924 103.148C261.702 104.037 261.878 106.391 262.382 107.038C269.256 105.872 282.416 101.157 285.165 98.7604C291.436 93.2918 297.669 76.3812 297.669 76.3812Z",
  fill: "#C78E6E"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M292.123 252.442C291.735 252.47 291.349 252.372 291.03 252.164C290.932 252.082 290.858 251.977 290.817 251.859C290.775 251.742 290.767 251.617 290.794 251.496C290.798 251.42 290.825 251.347 290.871 251.285C290.917 251.222 290.98 251.172 291.053 251.14C291.695 250.835 293.49 251.894 293.696 252.015C293.719 252.028 293.736 252.048 293.746 252.071C293.755 252.094 293.757 252.119 293.749 252.143C293.743 252.168 293.73 252.191 293.711 252.209C293.692 252.228 293.669 252.242 293.643 252.25C293.145 252.364 292.635 252.428 292.123 252.442ZM291.359 251.332C291.301 251.32 291.241 251.32 291.183 251.332C291.154 251.346 291.13 251.368 291.113 251.394C291.097 251.421 291.089 251.451 291.091 251.482C291.071 251.564 291.075 251.651 291.101 251.732C291.128 251.813 291.177 251.886 291.244 251.944C291.542 252.193 292.291 252.221 293.276 252.043C292.689 251.684 292.029 251.442 291.336 251.332H291.359Z",
  fill: "#FDBF21"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M293.605 252.25C293.585 252.256 293.564 252.256 293.544 252.25C292.971 251.951 291.894 250.778 292.055 250.18C292.079 250.086 292.136 250.001 292.218 249.94C292.3 249.88 292.401 249.847 292.505 249.846C292.608 249.833 292.712 249.841 292.811 249.869C292.91 249.898 293.001 249.945 293.078 250.01C293.712 250.514 293.75 252.065 293.75 252.143C293.754 252.166 293.749 252.19 293.737 252.211C293.724 252.231 293.705 252.248 293.682 252.257C293.656 252.262 293.629 252.259 293.605 252.25ZM292.582 250.081H292.528C292.353 250.081 292.33 250.173 292.322 250.209C292.23 250.557 292.91 251.446 293.475 251.866C293.473 251.265 293.273 250.679 292.903 250.187C292.814 250.115 292.699 250.077 292.582 250.081Z",
  fill: "#FDBF21"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M271.845 251.553C271.377 251.705 270.869 251.705 270.401 251.553C270.295 251.499 270.205 251.422 270.14 251.327C270.074 251.233 270.035 251.125 270.027 251.013C270.017 250.942 270.027 250.871 270.055 250.805C270.083 250.739 270.129 250.681 270.187 250.636C270.798 250.124 273.296 250.636 273.579 250.735C273.605 250.742 273.629 250.756 273.646 250.777C273.662 250.798 273.671 250.823 273.67 250.849C273.671 250.876 273.664 250.902 273.649 250.925C273.634 250.948 273.612 250.966 273.586 250.977C273.024 251.213 272.441 251.406 271.845 251.553ZM270.6 250.707C270.512 250.723 270.431 250.76 270.363 250.813C270.339 250.83 270.32 250.853 270.309 250.88C270.298 250.906 270.296 250.935 270.302 250.963C270.307 251.037 270.332 251.11 270.375 251.173C270.417 251.236 270.476 251.289 270.546 251.325C270.951 251.525 271.891 251.368 273.105 250.892C272.287 250.7 271.44 250.637 270.6 250.707Z",
  fill: "#FDBF21"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M273.564 250.977H273.503C272.739 250.849 271.211 250.031 271.165 249.419C271.165 249.277 271.234 249.078 271.601 248.964C271.725 248.923 271.856 248.906 271.987 248.913C272.118 248.921 272.247 248.952 272.364 249.007C273.189 249.384 273.625 250.749 273.648 250.813C273.653 250.835 273.652 250.857 273.646 250.878C273.639 250.9 273.626 250.919 273.609 250.934C273.598 250.952 273.582 250.966 273.564 250.977ZM271.753 249.178H271.677C271.44 249.256 271.44 249.348 271.44 249.377C271.44 249.747 272.548 250.422 273.319 250.65C273.142 250.079 272.766 249.578 272.25 249.227C272.097 249.155 271.92 249.137 271.753 249.178Z",
  fill: "#FDBF21"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M262.572 102.728L254.606 106.141L253.682 108.275L256.622 110.117C256.622 110.117 262.121 109.562 263.687 106.269L262.572 102.728Z",
  fill: "#C78E6E"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M262.908 107.159C262.73 105.734 262.224 104.361 261.426 103.134L262.686 102.252C263.634 103.666 264.239 105.256 264.458 106.91L262.908 107.159Z",
  fill: "black"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M264.268 103.738C264.437 103.985 264.519 104.274 264.505 104.566C264.491 104.858 264.38 105.138 264.189 105.37C263.997 105.601 263.734 105.772 263.434 105.859C263.134 105.946 262.813 105.945 262.514 105.856C262.215 105.767 261.953 105.595 261.763 105.362C261.573 105.129 261.465 104.848 261.453 104.556C261.441 104.264 261.526 103.975 261.696 103.73C261.866 103.484 262.114 103.293 262.405 103.184C262.731 103.029 263.11 103 263.459 103.104C263.808 103.208 264.099 103.436 264.268 103.738Z",
  fill: "black"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M249.222 108.901L250.283 109.897L257.432 107.052L254.606 106.142L249.222 108.901Z",
  fill: "#C78E6E"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M279.918 238.881C279.964 238.881 281.002 241.597 281.002 241.597L270.432 245.736L268.766 242.849L279.918 238.881Z",
  fill: "black"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M301.526 242.33C301.571 242.33 301.877 245.067 301.877 245.067H290.298L289.473 241.924L301.526 242.33Z",
  fill: "black"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M299.739 74.3329C301.839 80.6405 293.628 89.2665 293.628 89.2665L282.286 84.9571C283.631 81.3113 285.181 77.7341 286.93 74.2404C290.413 67.25 297.615 67.9683 299.739 74.3329Z",
  fill: "#FDBF21"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M299.739 74.3329C301.839 80.6405 293.628 89.2665 293.628 89.2665L282.286 84.9571C283.631 81.3113 285.181 77.7341 286.93 74.2404C290.413 67.25 297.615 67.9683 299.739 74.3329Z",
  fill: "black"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M187.034 11.1345H182.153V11.867H187.034V11.1345Z",
  fill: "#FDBF21"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M250.212 40.1248L249.622 52.3296L250.408 52.3626L250.998 40.1578L250.212 40.1248Z",
  fill: "#FDBF21"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M248.695 14.4199H158.568L150.182 189.158H240.308L248.695 14.4199Z",
  fill: "#FDBF21"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.56,
  d: "M246.005 16.8235H155.879L147.493 191.562H237.619L246.005 16.8235Z",
  fill: "#FAFAFA"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.07,
  d: "M243.317 19.22H153.191L144.797 193.958H234.923L243.317 19.22Z",
  fill: "#FDBF21"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M233.06 95.4312H156.132L155.49 108.8H232.418L233.06 95.4312Z",
  fill: "white"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M198.437 85.6748H156.597L156.314 91.6553H198.154L198.437 85.6748Z",
  fill: "#FDBF21"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M231.326 131.514H154.398L153.756 144.883H230.684L231.326 131.514Z",
  fill: "white"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.47,
  d: "M217.218 162.939H165.487L164.716 178.961H216.447L217.218 162.939Z",
  fill: "#FDBF21"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M213.759 181.45H162.028C162.005 181.455 161.982 181.455 161.959 181.45C161.952 181.429 161.952 181.406 161.959 181.386L162.723 165.357C162.723 165.346 162.725 165.335 162.73 165.325C162.735 165.315 162.741 165.306 162.75 165.299C162.759 165.292 162.769 165.286 162.78 165.282C162.791 165.279 162.803 165.278 162.815 165.279H214.545C214.555 165.274 214.565 165.272 214.576 165.272C214.587 165.272 214.597 165.274 214.607 165.279C214.612 165.287 214.615 165.297 214.615 165.307C214.615 165.317 214.612 165.327 214.607 165.336L213.858 181.4C213.849 181.417 213.834 181.43 213.817 181.439C213.799 181.448 213.779 181.452 213.759 181.45ZM162.119 181.279H213.667L214.431 165.421H162.883L162.119 181.279Z",
  fill: "white"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M189.401 121.757H154.863L154.58 127.745H189.111L189.401 121.757Z",
  fill: "#FDBF21"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M216.234 52.2447C216.036 56.1356 214.55 59.8742 211.979 62.9472C210.076 65.2684 207.627 67.1528 204.821 68.4558C202.014 69.7588 198.924 70.4457 195.787 70.4638C193.253 70.4818 190.741 70.0165 188.407 69.0965C186.073 68.1766 183.966 66.8214 182.216 65.1146C180.466 63.4077 179.109 61.3854 178.23 59.172C177.351 56.9586 176.968 54.6011 177.105 52.2447C177.374 47.355 179.638 42.7456 183.436 39.359C187.234 35.9724 192.278 34.0646 197.536 34.0257C200.073 34.0036 202.587 34.4661 204.924 35.3845C207.261 36.3029 209.37 37.6577 211.123 39.3651C212.875 41.0726 214.233 43.0965 215.112 45.3118C215.991 47.5271 216.373 49.8867 216.234 52.2447Z",
  fill: "white"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M218.073 37.8371C218.024 38.8717 217.628 39.866 216.943 40.6816C216.436 41.2981 215.784 41.7986 215.038 42.145C214.291 42.4913 213.469 42.6742 212.635 42.6799C211.827 42.6845 211.03 42.5047 210.314 42.1564C209.598 41.8081 208.984 41.3017 208.526 40.6816C207.92 39.8437 207.62 38.8462 207.671 37.8371C207.745 36.5389 208.348 35.3157 209.357 34.4172C210.366 33.5186 211.705 33.0123 213.101 33.0014C213.775 32.9957 214.443 33.1184 215.063 33.3621C215.684 33.6058 216.244 33.9652 216.71 34.4183C217.176 34.8713 217.537 35.4084 217.772 35.9964C218.006 36.5843 218.109 37.2108 218.073 37.8371Z",
  fill: "#FDBF21"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M164.418 102.116C164.382 102.689 164.113 103.228 163.666 103.624C163.22 104.02 162.629 104.243 162.012 104.249C161.715 104.253 161.419 104.199 161.145 104.092C160.87 103.985 160.622 103.826 160.416 103.626C160.21 103.426 160.05 103.189 159.946 102.929C159.842 102.67 159.797 102.393 159.813 102.116C159.846 101.542 160.113 101.001 160.561 100.604C161.008 100.208 161.601 99.9853 162.219 99.9825C162.516 99.9802 162.811 100.035 163.085 100.142C163.359 100.25 163.606 100.408 163.812 100.608C164.018 100.808 164.178 101.044 164.282 101.304C164.387 101.563 164.433 101.839 164.418 102.116Z",
  fill: "black"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M174.714 102.116C174.679 102.69 174.411 103.229 173.964 103.626C173.518 104.022 172.925 104.245 172.308 104.249C172.011 104.252 171.717 104.197 171.443 104.09C171.17 103.982 170.923 103.824 170.717 103.624C170.512 103.424 170.353 103.187 170.249 102.928C170.146 102.668 170.101 102.392 170.116 102.116C170.149 101.543 170.416 101.003 170.862 100.607C171.307 100.21 171.898 99.9872 172.515 99.9826C172.812 99.9793 173.108 100.033 173.382 100.14C173.657 100.247 173.905 100.406 174.111 100.606C174.317 100.806 174.477 101.043 174.581 101.303C174.685 101.562 174.73 101.839 174.714 102.116Z",
  fill: "black"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M185.017 102.116C184.982 102.69 184.714 103.229 184.267 103.626C183.821 104.022 183.228 104.245 182.611 104.249C182.314 104.252 182.019 104.197 181.745 104.09C181.471 103.982 181.224 103.824 181.018 103.624C180.812 103.424 180.652 103.188 180.548 102.928C180.443 102.669 180.397 102.392 180.412 102.116C180.447 101.542 180.715 101.003 181.162 100.606C181.608 100.21 182.201 99.9871 182.818 99.9826C183.115 99.9793 183.411 100.033 183.685 100.14C183.96 100.247 184.208 100.406 184.414 100.606C184.62 100.806 184.78 101.043 184.884 101.303C184.988 101.562 185.033 101.839 185.017 102.116Z",
  fill: "black"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M162.684 138.199C162.647 138.772 162.379 139.311 161.932 139.707C161.486 140.102 160.895 140.326 160.278 140.332C159.981 140.335 159.686 140.28 159.412 140.173C159.138 140.065 158.89 139.907 158.684 139.707C158.478 139.507 158.318 139.27 158.214 139.011C158.11 138.752 158.064 138.475 158.078 138.199C158.113 137.625 158.381 137.085 158.828 136.689C159.275 136.293 159.867 136.07 160.484 136.065C160.782 136.063 161.076 136.118 161.35 136.225C161.624 136.333 161.872 136.491 162.078 136.691C162.284 136.89 162.444 137.127 162.548 137.387C162.652 137.646 162.698 137.922 162.684 138.199Z",
  fill: "black"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M172.98 138.199C172.945 138.771 172.678 139.31 172.233 139.706C171.788 140.102 171.198 140.326 170.582 140.332C170.284 140.336 169.989 140.282 169.714 140.175C169.44 140.068 169.192 139.909 168.986 139.709C168.78 139.509 168.62 139.272 168.516 139.012C168.412 138.753 168.367 138.476 168.382 138.199C168.417 137.625 168.685 137.086 169.132 136.689C169.579 136.293 170.171 136.07 170.788 136.066C171.085 136.063 171.38 136.117 171.653 136.225C171.927 136.333 172.174 136.491 172.379 136.691C172.585 136.891 172.744 137.128 172.847 137.387C172.951 137.646 172.996 137.923 172.98 138.199Z",
  fill: "black"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M183.306 138.198C183.271 138.772 183.003 139.312 182.556 139.708C182.109 140.104 181.517 140.327 180.9 140.332C180.603 140.333 180.309 140.278 180.035 140.17C179.762 140.062 179.515 139.904 179.309 139.704C179.103 139.505 178.943 139.268 178.839 139.01C178.734 138.751 178.687 138.475 178.701 138.198C178.737 137.625 179.006 137.087 179.452 136.691C179.899 136.295 180.49 136.071 181.107 136.065C181.404 136.062 181.699 136.115 181.974 136.223C182.249 136.33 182.497 136.488 182.703 136.688C182.909 136.888 183.069 137.125 183.173 137.385C183.276 137.645 183.322 137.922 183.306 138.198Z",
  fill: "black"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M193.587 138.199C193.55 138.772 193.281 139.311 192.835 139.707C192.388 140.103 191.797 140.326 191.181 140.332C190.884 140.334 190.589 140.279 190.316 140.171C190.042 140.063 189.795 139.904 189.589 139.705C189.384 139.505 189.224 139.269 189.119 139.01C189.015 138.751 188.968 138.475 188.981 138.199C189.018 137.626 189.286 137.087 189.733 136.691C190.179 136.295 190.77 136.072 191.387 136.065C191.684 136.063 191.979 136.118 192.253 136.225C192.527 136.333 192.775 136.491 192.981 136.691C193.187 136.89 193.347 137.127 193.451 137.387C193.555 137.646 193.601 137.922 193.587 138.199Z",
  fill: "black"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M203.929 138.199C203.892 138.772 203.623 139.311 203.177 139.707C202.73 140.103 202.139 140.326 201.523 140.332C201.225 140.336 200.93 140.282 200.655 140.175C200.381 140.068 200.133 139.909 199.926 139.709C199.72 139.509 199.56 139.272 199.456 139.012C199.353 138.753 199.307 138.476 199.323 138.199C199.358 137.625 199.626 137.085 200.073 136.689C200.52 136.293 201.112 136.07 201.729 136.065C202.026 136.063 202.321 136.118 202.595 136.225C202.869 136.333 203.117 136.491 203.323 136.691C203.528 136.891 203.688 137.127 203.793 137.387C203.897 137.646 203.943 137.922 203.929 138.199Z",
  fill: "black"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M202.366 51.2959C205.562 48.3852 205.732 43.7197 202.744 40.8752C199.757 38.0307 194.743 38.0844 191.546 40.9951C188.35 43.9058 188.18 48.5713 191.168 51.4158C194.155 54.2602 199.169 54.2066 202.366 51.2959Z",
  fill: "#FDBF21"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M211.979 62.9471C210.076 65.2683 207.627 67.1527 204.82 68.4557C202.013 69.7587 198.923 70.4456 195.786 70.4637C192.745 70.4877 189.744 69.8146 187.048 68.5038C184.352 67.1929 182.044 65.2846 180.327 62.9471C184.039 59.5052 189.913 57.2581 196.42 57.2581C202.928 57.2581 208.595 59.5052 211.979 62.9471Z",
  fill: "#FDBF21"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M202.366 51.2959C205.562 48.3852 205.732 43.7197 202.744 40.8752C199.757 38.0307 194.743 38.0844 191.546 40.9951C188.35 43.9058 188.18 48.5713 191.168 51.4158C194.155 54.2602 199.169 54.2066 202.366 51.2959Z",
  fill: "white"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M211.979 62.9471C210.076 65.2683 207.627 67.1527 204.82 68.4557C202.013 69.7587 198.923 70.4456 195.786 70.4637C192.745 70.4877 189.744 69.8146 187.048 68.5038C184.352 67.1929 182.044 65.2846 180.327 62.9471C184.039 59.5052 189.913 57.2581 196.42 57.2581C202.928 57.2581 208.595 59.5052 211.979 62.9471Z",
  fill: "white"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M99.6037 112.022C98.8781 113.502 98.1143 115.13 97.4498 116.709C96.7853 118.287 96.1056 119.916 95.5174 121.537C94.3167 124.733 93.4021 128.015 92.7831 131.351L92.6151 132.396C92.5991 132.576 92.6172 132.756 92.6685 132.93C92.8488 133.519 93.1327 134.076 93.5087 134.579C94.4896 135.881 95.6274 137.074 96.8999 138.135C98.2415 139.297 99.6489 140.391 101.116 141.413C102.582 142.466 104.125 143.49 105.645 144.457L104.217 146.953C100.588 145.481 97.1427 143.642 93.9441 141.47C92.2376 140.311 90.6975 138.954 89.3614 137.431C88.5694 136.524 87.9518 135.497 87.5359 134.394C87.2941 133.706 87.1704 132.986 87.1693 132.261C87.1693 132.09 87.1693 131.842 87.1693 131.721V131.372L87.2457 130.661C87.6836 126.956 88.5203 123.302 89.7433 119.752C90.339 118.003 90.9729 116.261 91.6985 114.561C92.4241 112.862 93.1726 111.198 94.0968 109.469L99.6037 112.022Z",
  fill: "#C78E6E"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M104.569 144.016L109.969 141.47L108.572 146.988C108.572 146.988 104.867 147.955 103.149 146.277L104.569 144.016Z",
  fill: "#C78E6E"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M114.911 142.373L113.475 146.939L108.572 146.988L109.969 141.47L114.911 142.373Z",
  fill: "#C78E6E"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M122.533 85.3977C122.822 86.3832 123.224 87.3369 123.732 88.2422C123.584 88.399 123.393 88.5155 123.179 88.5794C122.965 88.6432 122.737 88.652 122.518 88.6049L122.533 85.3977Z",
  fill: "#DF5753"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M122.373 85.4403C122.689 85.4403 122.946 85.0742 122.946 84.6225C122.946 84.1708 122.689 83.8047 122.373 83.8047C122.056 83.8047 121.8 84.1708 121.8 84.6225C121.8 85.0742 122.056 85.4403 122.373 85.4403Z",
  fill: "black"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M122.204 83.8334L123.365 83.5276C123.365 83.5276 122.8 84.3667 122.204 83.8334Z",
  fill: "black"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M107.616 90.6172C108.311 93.9239 109.006 99.9899 106.516 102.201C106.516 102.201 107.494 105.558 114.101 105.558C121.364 105.558 117.568 102.201 117.568 102.201C113.604 101.32 113.704 98.5818 114.399 96.0075L107.616 90.6172Z",
  fill: "#C78E6E"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M105.684 83.0795C106.051 88.605 106.081 90.9517 109.075 93.7891C113.589 98.0559 120.799 96.4345 122.212 90.9446C123.488 85.9667 122.678 77.7745 116.866 75.5771C115.59 75.0878 114.201 74.9095 112.831 75.0593C111.46 75.2091 110.153 75.6819 109.034 76.433C107.914 77.1841 107.019 78.1887 106.433 79.3517C105.847 80.5148 105.589 81.7978 105.684 83.0795Z",
  fill: "#C78E6E"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M106.273 76.8639C103.294 77.8737 99.3223 77.1199 100.88 85.6748C102.53 94.7346 99.9944 97.7142 99.9944 97.7142C99.9944 97.7142 111.291 99.9542 122.824 97.5791C122.824 97.5791 119.303 91.8474 120.288 87.6233C121.548 82.2898 120.555 80.32 120.555 80.32C120.555 80.32 110.458 75.4417 106.273 76.8639Z",
  fill: "black"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M118.874 85.9596C118.877 87.0103 119.2 88.0385 119.806 88.9251C120.616 90.0771 121.57 89.6362 121.807 88.413C122.021 87.3392 121.861 85.4405 120.83 84.7009C119.798 83.9614 118.89 84.6867 118.874 85.9596Z",
  fill: "#C78E6E"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M103.683 77.7956C102.828 75.5556 106.906 72.1066 115.537 73.5289C124.168 74.9511 124.542 81.6428 124.542 81.6428L122.801 79.7086L122.877 81.7424L114.01 83.3282L103.683 77.7956Z",
  fill: "black"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M104.417 102.578C104.366 102.254 104.453 101.923 104.66 101.658C104.867 101.392 105.177 101.212 105.524 101.156C108.213 100.744 114.323 99.9045 117.393 100.303C119.685 100.601 120.28 101.839 120.38 102.856C120.395 103.034 120.37 103.213 120.305 103.381C120.24 103.549 120.137 103.702 120.003 103.83C119.869 103.958 119.707 104.058 119.529 104.123C119.35 104.188 119.158 104.217 118.967 104.207L105.692 103.652C105.379 103.637 105.081 103.523 104.849 103.327C104.616 103.131 104.464 102.867 104.417 102.578Z",
  fill: "#FDBF21"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M104.417 102.578C104.366 102.254 104.453 101.923 104.66 101.658C104.867 101.392 105.177 101.212 105.524 101.156C108.213 100.744 114.323 99.9045 117.393 100.303C119.685 100.601 120.28 101.839 120.38 102.856C120.395 103.034 120.37 103.213 120.305 103.381C120.24 103.549 120.137 103.702 120.003 103.83C119.869 103.958 119.707 104.058 119.529 104.123C119.35 104.188 119.158 104.217 118.967 104.207L105.692 103.652C105.379 103.637 105.081 103.523 104.849 103.327C104.616 103.131 104.464 102.867 104.417 102.578Z",
  fill: "black"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M112.092 226.812L117.018 229.998L125.259 219.595L120.333 216.416L112.092 226.812Z",
  fill: "#C78E6E"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M100.605 226.606L105.807 229.365L113.101 218.364L107.899 215.605L100.605 226.606Z",
  fill: "#C78E6E"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M125.252 219.594L121.005 224.956L116.079 221.778L120.325 216.416L125.252 219.594Z",
  fill: "#CF6F64"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M107.891 215.605L113.1 218.371L109.342 224.039L104.133 221.273L107.891 215.605Z",
  fill: "#CF6F64"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M116.247 137.31C116.247 137.31 135.479 159.874 131.866 181.457C128.956 198.886 112.076 222.489 112.076 222.489L104.141 218.819C109.734 208.384 114.508 197.584 118.423 186.506C119.631 183.066 119.983 179.416 119.454 175.831C118.925 172.246 117.528 168.82 115.368 165.812C105.622 152.563 90.0106 160.45 100.513 137.31H116.247Z",
  fill: "#FDBF21"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M116.247 137.31C116.247 137.31 135.479 159.874 131.866 181.457C128.956 198.886 112.076 222.489 112.076 222.489L104.141 218.819C109.734 208.384 114.508 197.584 118.423 186.506C119.631 183.066 119.983 179.416 119.454 175.831C118.925 172.246 117.528 168.82 115.368 165.812C105.622 152.563 90.0106 160.45 100.513 137.31H116.247Z",
  fill: "black"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M125.68 151.803L122.885 149.214C122.885 149.421 128.3 180.547 129.82 189.294C130.717 186.738 131.403 184.123 131.874 181.471C133.661 170.882 129.927 160.066 125.68 151.803Z",
  fill: "black"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M124.833 137.31C124.833 137.31 147.991 165.67 148.647 182.673C149.19 196.895 123.443 224.451 123.443 224.451L115.958 219.943C115.958 219.943 131.027 200.373 134.823 184.386C133.357 168.543 102.347 137.31 102.347 137.31H124.833Z",
  fill: "#FDBF21"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M124.833 137.31C124.833 137.31 147.991 165.67 148.647 182.673C149.19 196.895 123.443 224.451 123.443 224.451L115.958 219.943C115.958 219.943 131.027 200.373 134.823 184.386C133.357 168.543 102.347 137.31 102.347 137.31H124.833Z",
  fill: "black"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M96.182 103.467C93.7074 104.015 91.332 112.392 91.332 112.392L101.009 118.408C101.009 118.408 104.232 111.781 103.102 108.879C101.933 105.857 99.2906 102.778 96.182 103.467Z",
  fill: "#FDBF21"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M98.0766 108.865L97.4045 116.168L101.002 118.415C101.995 116.333 102.731 114.152 103.194 111.915L98.0766 108.865Z",
  fill: "black"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M127.697 103.631C127.697 103.631 130.553 104.562 124.832 137.303H100.498C100.911 128.058 100.918 122.369 96.1829 103.467C99.5902 102.814 103.044 102.391 106.517 102.202C110.196 101.956 113.89 101.956 117.569 102.202C122.32 102.607 127.697 103.631 127.697 103.631Z",
  fill: "#FDBF21"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M130.171 108.865C130.72 110.287 131.301 111.816 131.912 113.288C132.523 114.76 133.103 116.275 133.722 117.768L135.593 122.234L136.067 123.351L136.311 123.905L136.426 124.183C136.426 124.232 136.426 124.233 136.426 124.225C136.286 124.042 136.103 123.891 135.891 123.784C135.589 123.619 135.248 123.524 134.898 123.507C134.607 123.499 134.318 123.55 134.051 123.656C133.699 123.806 133.699 123.87 133.707 123.863C133.77 123.815 133.827 123.76 133.875 123.699C134.298 123.182 134.664 122.627 134.967 122.042C135.326 121.388 135.67 120.691 136.013 119.987C136.686 118.565 137.304 117.093 137.923 115.607C138.542 114.12 139.13 112.62 139.703 111.105L141.444 106.568L144.385 107.279C143.804 110.522 143.056 113.679 142.154 116.894C141.719 118.494 141.207 120.08 140.627 121.68C140.336 122.483 140.016 123.28 139.649 124.097C139.267 124.985 138.796 125.837 138.244 126.643C138.041 126.914 137.816 127.171 137.572 127.411C137.182 127.803 136.708 128.116 136.182 128.329C135.714 128.515 135.208 128.603 134.7 128.585C134.13 128.565 133.576 128.411 133.088 128.137C132.513 127.802 132.035 127.341 131.698 126.793C131.584 126.608 131.484 126.423 131.416 126.288L131.27 126.017L130.98 125.463L130.4 124.361C129.636 122.881 128.872 121.388 128.208 119.888C127.543 118.387 126.84 116.865 126.184 115.336C125.527 113.807 124.939 112.278 124.381 110.629L130.171 108.865Z",
  fill: "#C78E6E"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M127.696 103.631C130.621 104.278 133.913 112.328 133.913 112.328L125.214 119.219C125.214 119.219 119.585 110.444 120.723 107.549C121.906 104.534 123.877 102.785 127.696 103.631Z",
  fill: "#FDBF21"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M142.827 104.022L145.882 101.647L148.005 104.726L146.439 107.293C146.439 107.293 143.949 109.427 141.75 108.339C141.401 107.608 141.317 106.791 141.511 106.012C141.706 105.233 142.167 104.535 142.827 104.022Z",
  fill: "#C78E6E"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M151.396 101.654L151.167 102.429L146.332 103.183L145.859 101.647L151.396 101.654Z",
  fill: "#C78E6E"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M124.038 224.814L115.316 219.566L116.881 217.034L126.681 222.645L124.038 224.814Z",
  fill: "#FDBF21"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M109.22 228.996C108.455 228.908 107.719 228.666 107.066 228.284C107.039 228.276 107.016 228.259 106.999 228.238C106.983 228.216 106.974 228.19 106.974 228.164C106.974 228.137 106.983 228.111 106.999 228.089C107.016 228.068 107.039 228.051 107.066 228.043C107.303 227.971 109.357 227.381 109.953 227.836C110.02 227.888 110.071 227.956 110.1 228.032C110.13 228.108 110.137 228.19 110.121 228.27C110.11 228.398 110.065 228.522 109.989 228.629C109.913 228.736 109.808 228.823 109.686 228.882C109.543 228.954 109.383 228.993 109.22 228.996ZM107.501 228.213C108.456 228.668 109.22 228.832 109.586 228.661C109.666 228.62 109.733 228.561 109.782 228.488C109.83 228.416 109.857 228.334 109.861 228.249C109.861 228.135 109.861 228.085 109.793 228.057C109.472 227.815 108.326 228 107.486 228.213H107.501Z",
  fill: "black"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M107.12 228.334C107.08 228.333 107.041 228.318 107.013 228.291C107.002 228.272 106.996 228.25 106.996 228.227C106.996 228.205 107.002 228.183 107.013 228.163C107.013 228.099 107.509 226.556 108.289 226.208C108.388 226.165 108.496 226.144 108.605 226.144C108.715 226.144 108.823 226.165 108.922 226.208C109.03 226.239 109.123 226.303 109.186 226.39C109.25 226.476 109.281 226.58 109.274 226.684C109.22 227.324 107.823 228.206 107.181 228.355L107.12 228.334ZM108.602 226.393C108.527 226.395 108.454 226.412 108.388 226.442C107.914 226.656 107.525 227.488 107.334 227.993C108.006 227.73 108.93 227.033 108.961 226.641C108.961 226.577 108.961 226.499 108.785 226.428C108.728 226.4 108.666 226.38 108.602 226.371V226.393Z",
  fill: "black"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M120.119 232.068C119.256 232.068 118.057 231.036 117.4 230.404C117.383 230.382 117.374 230.356 117.374 230.329C117.374 230.302 117.383 230.276 117.4 230.254C117.415 230.231 117.437 230.213 117.462 230.2C117.488 230.188 117.516 230.182 117.545 230.183C117.851 230.183 120.501 230.553 120.875 231.25C120.915 231.312 120.936 231.383 120.936 231.456C120.936 231.529 120.915 231.6 120.875 231.662C120.819 231.771 120.734 231.864 120.629 231.934C120.523 232.004 120.401 232.047 120.272 232.06L120.119 232.068ZM117.904 230.503C118.867 231.371 119.714 231.854 120.196 231.797C120.28 231.787 120.36 231.758 120.429 231.712C120.499 231.666 120.555 231.605 120.593 231.534C120.61 231.51 120.619 231.481 120.619 231.452C120.619 231.423 120.61 231.395 120.593 231.371C120.394 230.987 118.981 230.66 117.904 230.503Z",
  fill: "black"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M117.988 230.468C117.817 230.472 117.645 230.46 117.477 230.432C117.453 230.429 117.431 230.42 117.412 230.406C117.393 230.392 117.379 230.374 117.37 230.354C117.358 230.333 117.352 230.31 117.352 230.286C117.352 230.263 117.358 230.24 117.37 230.219C117.415 230.169 118.447 229.01 119.424 228.932C119.701 228.912 119.975 228.993 120.188 229.159C120.486 229.401 120.471 229.614 120.394 229.749C120.203 230.233 118.882 230.468 117.988 230.468ZM117.79 230.205C118.645 230.247 120.012 229.984 120.188 229.636C120.188 229.636 120.249 229.522 120.05 229.365C119.971 229.301 119.879 229.253 119.779 229.224C119.679 229.195 119.574 229.185 119.47 229.195C118.811 229.366 118.225 229.721 117.79 230.212V230.205Z",
  fill: "black"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M107.326 227.566L100.849 225.86C100.738 225.828 100.617 225.836 100.512 225.882C100.406 225.928 100.322 226.009 100.276 226.108L98.092 230.681C98.0407 230.798 98.0166 230.924 98.0213 231.05C98.026 231.177 98.0594 231.301 98.1193 231.414C98.1792 231.528 98.2642 231.628 98.3688 231.709C98.4733 231.79 98.595 231.849 98.7259 231.883C101.017 232.437 102.117 232.594 104.966 233.355C106.723 233.81 109.228 234.656 111.649 235.296C114.07 235.936 114.88 233.739 113.94 233.269C109.694 231.179 109.358 229.714 108.197 228.149C107.989 227.866 107.681 227.66 107.326 227.566Z",
  fill: "#FDBF21"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M117.576 229.571L112.046 226.016C111.953 225.952 111.837 225.923 111.722 225.933C111.606 225.944 111.499 225.993 111.42 226.073L107.754 229.742C107.665 229.837 107.598 229.948 107.558 230.069C107.519 230.19 107.507 230.317 107.525 230.442C107.542 230.567 107.588 230.687 107.659 230.795C107.73 230.902 107.825 230.994 107.937 231.065C109.885 232.281 110.893 232.771 113.33 234.343C114.857 235.31 117.813 237.458 119.875 238.795C121.937 240.132 123.473 238.297 122.739 237.571C119.455 234.307 118.737 232.259 118.195 230.403C118.101 230.067 117.881 229.772 117.576 229.571Z",
  fill: "#FDBF21"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M113.093 222.958L103.126 218.343L104.157 215.825L114.804 220.69L113.093 222.958Z",
  fill: "#FDBF21"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M100.132 135.973L99.2915 138.021C99.2075 138.177 99.4061 138.341 99.6887 138.341H124.955C125.176 138.341 125.359 138.241 125.375 138.113L125.589 136.079C125.589 135.944 125.413 135.823 125.176 135.823H100.529C100.455 135.817 100.38 135.827 100.311 135.853C100.242 135.879 100.18 135.92 100.132 135.973Z",
  fill: "#FDBF21"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M100.132 135.973L99.2915 138.021C99.2075 138.177 99.4061 138.341 99.6887 138.341H124.955C125.176 138.341 125.359 138.241 125.375 138.113L125.589 136.079C125.589 135.944 125.413 135.823 125.176 135.823H100.529C100.455 135.817 100.38 135.827 100.311 135.853C100.242 135.879 100.18 135.92 100.132 135.973Z",
  fill: "white"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M104.11 138.54H103.446C103.316 138.54 103.217 138.476 103.224 138.398L103.537 135.76C103.537 135.689 103.66 135.625 103.789 135.625H104.454C104.584 135.625 104.683 135.689 104.675 135.76L104.362 138.398C104.355 138.476 104.24 138.54 104.11 138.54Z",
  fill: "#FDBF21"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M119.691 138.54H119.034C118.905 138.54 118.805 138.476 118.813 138.398L119.118 135.76C119.118 135.689 119.248 135.625 119.378 135.625H120.035C120.165 135.625 120.272 135.689 120.256 135.76L119.951 138.398C119.913 138.476 119.829 138.54 119.691 138.54Z",
  fill: "#FDBF21"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M103.53 258.969C114.831 258.969 123.992 258.352 123.992 257.59C123.992 256.828 114.831 256.21 103.53 256.21C92.2293 256.21 83.0683 256.828 83.0683 257.59C83.0683 258.352 92.2293 258.969 103.53 258.969Z",
  fill: "#F5F5F5"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M115.995 255.642C112.374 254.66 108.357 253.401 105.928 252.086C105.859 252.043 105.783 252.022 105.714 251.986V236.726H113.039C113.595 236.695 114.117 236.468 114.499 236.09C114.881 235.713 115.094 235.214 115.094 234.695C115.094 234.177 114.881 233.678 114.499 233.3C114.117 232.923 113.595 232.696 113.039 232.665H105.752V163.103H101.353V232.665H94.0742C93.7769 232.649 93.4793 232.689 93.1994 232.784C92.9196 232.878 92.6634 233.025 92.4468 233.215C92.2301 233.405 92.0575 233.635 91.9395 233.889C91.8215 234.144 91.7606 234.418 91.7606 234.695C91.7606 234.973 91.8215 235.247 91.9395 235.501C92.0575 235.756 92.2301 235.985 92.4468 236.175C92.6634 236.365 92.9196 236.512 93.1994 236.607C93.4793 236.702 93.7769 236.742 94.0742 236.726H101.353V251.965C101.284 251.965 101.216 252.022 101.147 252.065C98.6798 253.401 94.6928 254.66 91.0725 255.62C90.8279 255.689 90.6179 255.837 90.4805 256.038C90.3431 256.238 90.2874 256.478 90.3234 256.713C90.3594 256.949 90.4847 257.165 90.6768 257.322C90.8689 257.478 91.1149 257.566 91.3704 257.569H115.697C115.941 257.553 116.172 257.46 116.351 257.305C116.531 257.15 116.648 256.943 116.682 256.717C116.717 256.492 116.668 256.262 116.543 256.066C116.418 255.87 116.224 255.72 115.995 255.642Z",
  fill: "#E0E0E0"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M117.117 156.02H89.9572C87.7721 156.02 86.0008 157.669 86.0008 159.703V167.22C86.0008 169.255 87.7721 170.904 89.9572 170.904H117.117C119.302 170.904 121.074 169.255 121.074 167.22V159.703C121.074 157.669 119.302 156.02 117.117 156.02Z",
  fill: "#FDBF21"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M89.7053 170.911V172.205C89.7053 173.272 90.9502 174.139 92.4778 174.139H114.627C116.155 174.139 117.4 173.272 117.4 172.205V170.911H89.7053Z",
  fill: "#FDBF21"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M89.7053 170.911V172.205C89.7053 173.272 90.9502 174.139 92.4778 174.139H114.627C116.155 174.139 117.4 173.272 117.4 172.205V170.911H89.7053Z",
  fill: "white"
});

function SvgMainImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 265,
    viewBox: "0 0 382 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref58), _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref168), _ref169, _ref170, _ref171, _ref172);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImage);
export default __webpack_public_path__ + "static/media/main-image.f1ec75dd.svg";
export { ForwardRef as ReactComponent };